import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 400px;
  height: 400px;
  border-radius: 8px;
  padding-bottom: 15px;

  overflow-y: auto;
  
  background-color: #fff;
`;

export const Header = styled.div`
  display: -webkit-flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
`;

export const ExtraOptions = styled.div`
  display: -webkit-flex;
  flex-direction: column;
  row-gap: 10px;
`;